// eslint-disable-next-line import/prefer-default-export
export enum TAGS {
	TRIAL_AI_TIS = 'trial_ai_tis_b2c',
	TIS_CREDITS = 'tis_credits_installments',
}
